import type { AlgebraOperation } from '../../shared/algebra.ts';
const words: Record<string, string> = {
  zero: '0',
  one: '1',
  two: '2',
  three: '3',
  four: '4',
  five: '5',
  six: '6',
  seven: '7',
  eight: '8',
  nine: '9',
  ten: '10',
  eleven: '11',
  twelve: '12',
  eighteen: '18',
  twenty: '20',
};
export function interpretOperation(
  source: string,
): AlgebraOperation | undefined {
  const cleaned = source
    .toLowerCase()
    .trim()
    .replace(/[.!?]$/, '')
    .replace(
      /\b(zero|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|eighteen|twenty)\b/g,
      (word) => words[word],
    )
    .replace(/\bnegative\s+/g, '-');
  const match = cleaned.match(
    /^(?:please\s+)?(add|subtract|multiply|divide)(?:\s+both\s+sides)?(?:\s+by)?\s+(-?\d+(?:\.\d+|\/\d+)?x?)(?:\s+(?:from|to|on)\s+both\s+sides)?$/,
  );
  if (!match) return undefined;
  return { kind: match[1] as AlgebraOperation['kind'], value: match[2] };
}
